export const Logo = () => (
  <span className="inline-flex flex-col items-center justify-center bg-[#1F3A93] border border-[#E0A96D]/50 px-4 py-1.5 rounded-[3px] shadow-[0_6px_24px_-8px_rgba(31,58,147,0.8)]">
    <span className="font-serif-d font-bold text-[1.6rem] leading-none text-[#F6EEDC] tracking-tight">Jungle</span>
    <span className="font-serif-d text-[8px] tracking-[0.35em] text-[#F6EEDC]/90 mt-0.5">NUTRIENT</span>
  </span>
);
